import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel error"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { useGettext } from 'vue3-gettext'
import Icon from './Icon.vue'
import Loader from './Loader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderErrorBlock',
  props: {
  errorTitle: { type: String, default: '' },
  errorMessage: { type: String, default: '' },
},
  setup(__props) {



const { $gettext } = useGettext()

return (_ctx: any,_cache: any) => {
  return (__props.errorMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          (__props.errorTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.errorTitle), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref($gettext)('Error')) + ":", 1)),
          _createVNode(Icon, {
            name: "danger",
            fill: "white",
            class: "pull-right"
          })
        ]),
        _createElementVNode("p", null, _toDisplayString(__props.errorMessage), 1)
      ]))
    : (_openBlock(), _createBlock(Loader, {
        key: 1,
        "ditto-plus": ""
      }))
}
}

})